module.exports = __webpack_public_path__ + "static/img/sm_running.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm_running.jpg
// module id = HSt+
// module chunks = 0